export enum Mindset {
    rain = "🌧️",
    cloud = "☁️",
    sun = "☀️",
}